import endpointMapper from '../_endpoints'
import { usePost } from '../_hooks/usePost'
import { useDispatch } from 'react-redux'

export const useCollectionService = () => {
  const [, postAddCollection] = usePost()
  const [, postRemoveCollection] = usePost()
  const dispatch = useDispatch()
  const userProfile = JSON.parse(localStorage.getItem('userInfoData'))

  const addCollectionItem = async (item) => {
    const resultAddCollection = await postAddCollection({
      url: endpointMapper.userCollections.create,
      data: {
        collectionId: item.collectionId,
        UserSid: userProfile?.sid
      }
    })
    return resultAddCollection
  }

  const removeCollectionItem = async (item) => {
    const resultRemoveCollection = await postRemoveCollection({
      url: endpointMapper.userCollections.delete,
      data: {
        UserSid: userProfile?.sid,
        collectionId: item?.collectionId
      }
    })

    return resultRemoveCollection
  }

  return { addCollectionItem, removeCollectionItem }
}
